function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export class InvalidQueryError extends Error {
  constructor(errors) {
    super(`Invalid query\n${errors.map(e => ' - ' + e).join('\n')}`);

    _defineProperty(this, "type", 'invalid-query');

    _defineProperty(this, "details", void 0);

    this.details = errors;
  }

}